var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99966 2.5C8.94132 2.5 7.99966 3.16667 7.64966 4.16667H2.49966V5.83333H4.12466L1.66633 11.6667C1.27466 13.3333 2.49966 14.1667 4.58299 14.1667C6.66632 14.1667 7.96632 13.3333 7.49966 11.6667L5.04132 5.83333H7.64132C7.91632 6.54167 8.45799 7.08333 9.16632 7.35833V16.6667H1.66633V18.3333H18.333V16.6667H10.833V7.35C11.5413 7.08333 12.083 6.54167 12.3497 5.83333H14.958L12.4997 11.6667C12.108 13.3333 13.333 14.1667 15.4163 14.1667C17.4997 14.1667 18.7997 13.3333 18.333 11.6667L15.8747 5.83333H17.4997V4.16667H12.358C11.9997 3.16667 11.058 2.5 9.99966 2.5ZM9.99966 4.16667C10.2207 4.16667 10.4326 4.25446 10.5889 4.41074C10.7452 4.56703 10.833 4.77899 10.833 5C10.833 5.22101 10.7452 5.43298 10.5889 5.58926C10.4326 5.74554 10.2207 5.83333 9.99966 5.83333C9.77864 5.83333 9.56668 5.74554 9.4104 5.58926C9.25412 5.43298 9.16632 5.22101 9.16632 5C9.16632 4.77899 9.25412 4.56703 9.4104 4.41074C9.56668 4.25446 9.77864 4.16667 9.99966 4.16667ZM4.58299 8.54167L5.83299 11.6667H3.33299L4.58299 8.54167ZM15.4163 8.54167L16.6663 11.6667H14.1663L15.4163 8.54167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleBalance);
export default __webpack_public_path__ + "static/media/scale-balance.caefb6d68c203a3d9a0effa05adc350d.svg";
export { ForwardRef as ReactComponent };